import React, { useEffect, useState } from "react";
import { Button, Col, Form, Input, Row, Skeleton, Spin } from "antd";

import AppContainer from "~v2/components/AppContainer/AppContainer";

import { COLORS, FullSpan } from "~constants";
import { LoadingOutlined } from "@ant-design/icons";
import { getContacts, updateContacts } from "../../http-request/contacts";
import { contactInitialValue } from "./initialValue";
const antIcon = (
  <LoadingOutlined style={{ fontSize: 15, color: COLORS.blue1 }} spin />
);
const ContactsEdit = () => {
  const [isLoading, setisLoading] = useState(false);
  const [isLoadingContacts, setisLoadingContacts] = useState(false);
  const [contacts, setContacts] = useState();

  const loadContacts = async () => {
    setisLoadingContacts(true);
    await getContacts()
      .then(({ result }) => setContacts(result))
      .finally(() => setisLoadingContacts(false));
  };

  useEffect(() => {
    loadContacts();
  }, []);

  return (
    <AppContainer title="GENSAN TOURISM DEPT. CONTACT INFORMATION">
      <center>
        {!isLoadingContacts ? (
          <Form
            {...FullSpan}
            initialValues={contacts || contactInitialValue}
            style={{ margin: "15px 20px" }}
            onFinish={async (values) => {
              setisLoading(true);
              await updateContacts(values)
                .then(() => {
                  loadContacts();
                })
                .finally(() => setisLoading(false));
            }}
          >
            <Form.Item
              label={"Telephone Number"}
              name={"telephoneNumber"}
              rules={[
                { required: true, message: "Telephone Number is Required!" },
              ]}
            >
              <Input />
            </Form.Item>

            <Form.Item
              label={"Cellphone Number"}
              name={"cellphoneNumber"}
              rules={[
                { required: true, message: "Cellphone Number is Required!" },
              ]}
            >
              <Input />
            </Form.Item>

            <Form.Item
              label={"Facebook"}
              name={"facebook"}
              rules={[
                {
                  required: true,
                  message: "Facebook is required!",
                },
                () => ({
                  validator(_, value) {
                    if (
                      !value ||
                      value.startsWith("https://") ||
                      value.startsWith("http://")
                    ) {
                      return Promise.resolve();
                    }
                    return Promise.reject(
                      new Error("Link must include https or https")
                    );
                  },
                }),
              ]}
            >
              <Input />
            </Form.Item>
            <Form.Item
              label={"Email"}
              name={"email"}
              rules={[{ required: true, message: "Email is Required!" }]}
            >
              <Input />
            </Form.Item>
            <Form.Item
              label={"Website"}
              name={"website"}
              rules={[
                { required: true, message: "Website is Required!" },
                () => ({
                  validator(_, value) {
                    if (
                      !value ||
                      value.startsWith("https://") ||
                      value.startsWith("http://")
                    ) {
                      return Promise.resolve();
                    }
                    return Promise.reject(
                      new Error("Link must include https or https")
                    );
                  },
                }),
              ]}
            >
              <Input />
            </Form.Item>
            <Row style={{ marginTop: 20 }} align="middle" justify="center">
              <Col
                span={12}
                style={{ justifyContent: "flex-start", display: "flex" }}
              >
                <Button
                  htmlType="reset"
                  style={{ border: 0, backgroundColor: COLORS.orange }}
                >
                  DISCARD
                </Button>
              </Col>
              <Col
                span={12}
                style={{ justifyContent: "flex-end", display: "flex" }}
              >
                <Button disabled={isLoading} htmlType="submit" type="primary">
                  {isLoading ? <Spin indicator={antIcon} /> : "SAVE"}
                </Button>
              </Col>
            </Row>
          </Form>
        ) : (
          <Skeleton />
        )}
      </center>
    </AppContainer>
  );
};

export default ContactsEdit;
